(() => {
  if(window.__pk30SafePolicies)return;
  window.__pk30SafePolicies=true;
  let active=null;
  function findDialog(trigger) {
    return trigger?.closest('product-info')?.querySelector('[data-pk29-policy-dialog]') ||
      document.querySelector('body > [data-pk29-policy-dialog]') ||
      document.querySelector('[data-pk29-policy-dialog]');
  }
  function selectTab(dialog,kind,moveFocus=false){
    const current=kind==='shipping'?'shipping':'refund';
    dialog.querySelectorAll('[data-pk29-policy-tab]').forEach(btn=>{
      const selected=btn.dataset.pk29PolicyTab===current;
      btn.setAttribute('aria-selected',String(selected));
      btn.tabIndex=selected?0:-1;
      if(selected&&moveFocus)btn.focus({preventScroll:true});
    });
    dialog.querySelectorAll('[data-pk29-policy-panel]').forEach(panel=>{
      panel.hidden=panel.dataset.pk29PolicyPanel!==current;
    });
    const scroll=dialog.querySelector('[data-pk29-policy-scroll]');
    if(scroll)scroll.scrollTop=0;
  }
  function close(){
    if(!active)return;
    const {dialog,trigger,parent,next}=active;
    active=null;
    dialog.hidden=true;
    dialog.removeAttribute('data-pk30-open');
    if(parent?.isConnected){
      if(next?.parentNode===parent)parent.insertBefore(dialog,next);
      else parent.appendChild(dialog);
    }
    if(trigger?.isConnected)trigger.focus({preventScroll:true});
  }
  function open(trigger,kind){
    const dialog=findDialog(trigger);
    if(!dialog)return;
    if(active)close();
    const parent=dialog.parentNode;
    const next=dialog.nextSibling;
    active={dialog,trigger,parent,next};
    selectTab(dialog,kind);
    // The product's cinema uses global scroll listeners. Never move or lock
    // the page body: keep scrollY constant and portal the overlay to <body>.
    if(dialog.parentNode!==document.body)document.body.appendChild(dialog);
    dialog.hidden=false;
    dialog.setAttribute('data-pk30-open','true');
    dialog.querySelector('[data-pk29-policy-close]')?.focus({preventScroll:true});
  }
  function ensureNote(){
    document.querySelectorAll('product-info.pk20-atelier-edition [data-pk20-workshop]').forEach(workshop=>{
      if(workshop.querySelector('.pk30-measure-note'))return;
      const custom=workshop.querySelector('.pcsize');
      if(!custom||!workshop.querySelector('.pk25-summary'))return;
      const note=document.createElement('div');
      note.className='pk30-measure-note';
      note.innerHTML='<span class="pk30-measure-note__icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="m5 12 5 5L20 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="pk30-measure-note__copy"><strong>Özel ölçünüz özenle hazırlanır.</strong><small>Seçtiğiniz ölçü, tasarım ekibimiz tarafından baskı öncesinde oran, kompozisyon ve netlik açısından kontrol edilir. Görsel gelişigüzel esnetilmez; baskıya uygunluk için bir düzenleme gerekirse sizinle iletişime geçilir.</small></span>';
      workshop.querySelector('.pk25-summary').after(note);
    });
  }
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-pk29-policy-open]');
    if(trigger){
      event.preventDefault();
      open(trigger,trigger.dataset.pk29PolicyOpen);
      return;
    }
    if(active){
      const {dialog}=active;
      const closeButton=event.target.closest('[data-pk29-policy-close]');
      if(closeButton&&dialog.contains(closeButton)){event.preventDefault();close();return}
      const tab=event.target.closest('[data-pk29-policy-tab]');
      if(tab&&dialog.contains(tab)){selectTab(dialog,tab.dataset.pk29PolicyTab,true);return}
      if(event.target===dialog||event.target.closest('[data-pk30-policy-backdrop]')){
        event.preventDefault();close();return;
      }
    }
    const current=event.target.closest('.pk29-discovery');
    document.querySelectorAll('product-info .pk29-discovery[open]').forEach(detail=>{
      if(detail!==current)detail.removeAttribute('open');
    });
  });
  document.addEventListener('keydown',event=>{
    if(!active)return;
    const {dialog}=active;
    if(event.key==='Escape'){event.preventDefault();close();return}
    const tab=event.target.closest('[data-pk29-policy-tab]');
    if(tab&&dialog.contains(tab)&&['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){
      event.preventDefault();
      const kind=event.key==='Home'?'refund':event.key==='End'?'shipping':tab.dataset.pk29PolicyTab==='refund'?'shipping':'refund';
      selectTab(dialog,kind,true);
      return;
    }
    if(event.key==='Tab'){
      const focusable=[...dialog.querySelectorAll('button:not([disabled]):not([tabindex="-1"]),a[href], [tabindex="0"]')].filter(el=>!el.closest('[hidden]')&&el.getClientRects().length>0);
      if(!focusable.length){event.preventDefault();return}
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey&&(document.activeElement===first||!dialog.contains(document.activeElement))){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&(document.activeElement===last||!dialog.contains(document.activeElement))){event.preventDefault();first.focus()}
    }
  });
  // Prevent backdrop gestures from moving the page, but keep native scrolling
  // inside the actual policy text. No body position or scroll restoration.
  document.addEventListener('touchmove',event=>{
    if(!active)return;
    if(!event.target.closest('[data-pk29-policy-scroll]'))event.preventDefault();
  },{passive:false});
  document.addEventListener('wheel',event=>{
    if(!active)return;
    if(!event.target.closest('[data-pk29-policy-scroll]'))event.preventDefault();
  },{passive:false});
  document.addEventListener('shopify:section:load',ensureNote);
  document.addEventListener('DOMContentLoaded',ensureNote);
  if(document.readyState!=='loading')ensureNote();
  window.addEventListener('pagehide',close);
})();
